import React from "react";
import { Link } from "react-router-dom";

/**
 * Greengold site wordmark — typographic + 3×3 dot glyph.
 *
 * Reverted from the client-supplied "GreenGOLD" PNG lockup back to the
 * original in-code mark: a 3×3 gold-dot glyph rendered inline (no image
 * request, no baked-in padding) alongside the serif "Greengold" text.
 */
export default function Wordmark({ compact = false, to = "/" }) {
  const glyphSize = compact ? 24 : 34;
  const textSize = compact ? 15 : 20;

  return (
    <Link
      to={to}
      data-testid="wordmark-home-link"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 12,
        textDecoration: "none",
        color: "var(--paper)",
        lineHeight: 1,
      }}
    >
      <span
        aria-hidden
        data-testid="wordmark-dot-glyph"
        style={{
          position: "relative",
          width: glyphSize,
          height: glyphSize,
          display: "inline-grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gridTemplateRows: "repeat(3, 1fr)",
          gap: Math.max(2, Math.round(glyphSize * 0.09)),
          flexShrink: 0,
        }}
      >
        {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((i) => {
          // Diagonal (indices 0, 4, 8) is gold; the rest is a subtle
          // paper-white at low opacity — matching the pre-PNG mark.
          const gold = [0, 4, 8].includes(i);
          return (
            <span
              key={i}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: 999,
                background: gold ? "var(--gold)" : "rgba(255,255,255,0.28)",
                boxShadow: gold
                  ? "0 0 12px rgba(244,169,31,0.55)"
                  : "none",
              }}
            />
          );
        })}
      </span>
      <span
        style={{
          fontFamily: "Fraunces, Georgia, serif",
          fontWeight: 500,
          letterSpacing: "-0.01em",
          fontSize: textSize,
          lineHeight: 1,
        }}
      >
        Greengold
      </span>
    </Link>
  );
}
